export class ProductItem {
	item_LiheId?: string // Actually the "Lihe_Id" variable in the dataLayer - format string ->> Example ?: 147
	item_LiheName?: string // Actually the "Lihe_Nom" variable in the dataLayer - format string ->> Example ?: Résidence Vacanceole Les Chalets & Balcons de la Vanoise
	item_PrestIds?: string[] // List of prestIdS - format array ->> Example ?: ['first id', 'second id', 'third id']
	item_PrestNames?: string[] // List of prestNameS - format array ->> Example ?: ['Studio cabine 4 personnes', '3 pièces 4/6 personnes', '3 pièces 6/8 personnes' ...]
	item_price_ati?: number // Item price all taxes included - format string
	// item_price_tf?: string; // Item price taxes free - format string
	page_category1?: string // 1st level of product category (which is displayed in the breadcrumb) - format string ->> Example ?: Alpes du Nord
	page_category2?: string // 2nd level of product category (which is displayed in the breadcrumb) - format string ->> Example ?: Espace Haute Maurienne Vanoise
	page_category3?: string // 3rd level of product category (which is displayed in the breadcrumb) - format string ->> Example ?: Location La Norma
	page_category4?: string // 4th level of product category (which is displayed in the breadcrumb) - format string ->> Example ?: If exists ?
	item_variant?: string // Actually the "Category" variable in the dataLayer - format string ->> Example ?: Ski
	item_ville_name?: string // Actually the "Ville_Nom" variable in the dataLayer - format string ->> Example ?: La Norma
	item_ville_id?: string // Actually the "Ville_Id" variable in the dataLayer - format string ->> Example ?: 83
	item_region_name?: string // Actually the "Region_Nom" variable in the dataLayer - format string ->> Example ?: Alpes du Nord
	item_region_id?: string // Actually the "Region_Id" variable in the dataLayer - format string ->> Example ?: 3
	item_pays_name?: string // Actually the "Pays_Nom" variable in the dataLayer - format string ->> Example ?: France
	item_pays_id?: string // Actually the "Pays_Nom" variable in the dataLayer - format string ->> Example ?: FR
	item_begin_date?: string // Actually the "Date_debut" variable in the dataLayer - format string ->> Example ?: "28/06/2023"
	item_end_date?: string // End Date - format string ->> Example ?: "14/07/2023"
	item_duration?: string // Choosen Duration - format string ->> Example ?: "6 days"
	item_reviews_note?: string // Reviews indice - format string ->> Example ?: "4,5"
	item_reviews?: string // Reviews - format string ->> Example ?: "355"
	position?: number // position in the list - format integar ->> Example ?: 12
	pageName?: string

	constructor(
		item_LiheId?: string,
		item_LiheName?: string,
		item_PrestIds?: string[],
		item_PrestNames?: string[],
		item_price_ati?: number, // Chepeast prest
		// item_price_tf?: string,
		page_category1?: string,
		page_category2?: string,
		page_category3?: string,
		page_category4?: string,
		item_variant?: string, // lodingType TODO confirm
		item_ville_name?: string,
		item_ville_id?: string,
		item_region_name?: string,
		item_region_id?: string,
		item_pays_name?: string, // country
		item_pays_id?: string, // country
		item_begin_date?: string,
		item_end_date?: string,
		item_duration?: string,
		item_reviews_note?: string,
		item_reviews?: string,
		position?: number,
		pageName?: string
	) {
		this.item_LiheId = item_LiheId
		;(this.item_LiheName = item_LiheName),
			(this.item_PrestIds = item_PrestIds),
			(this.item_PrestNames = item_PrestNames),
			(this.item_price_ati = item_price_ati),
			// (this.item_price_tf = item_price_tf),
			(this.page_category1 = page_category1),
			(this.page_category2 = page_category2),
			(this.page_category3 = page_category3),
			(this.page_category4 = page_category4),
			(this.item_variant = item_variant),
			(this.item_ville_name = item_ville_name),
			(this.item_ville_id = item_ville_id),
			(this.item_region_name = item_region_name),
			(this.item_region_id = item_region_id),
			(this.item_pays_name = item_pays_name),
			(this.item_pays_id = item_pays_id),
			(this.item_begin_date = item_begin_date),
			(this.item_end_date = item_end_date),
			(this.item_duration = item_duration),
			(this.item_reviews_note = item_reviews_note),
			(this.item_reviews = item_reviews),
			(this.position = position)
		this.pageName = pageName
	}

	public isValid(): void {
		if (typeof this.item_LiheId === "undefined")
			throw new Error("this.item_LiheId is mandatory in ProductItem")
		if (typeof this.item_LiheName === "undefined")
			throw new Error("this.item_LiheName is mandatory in ProductItem")
		if (typeof this.item_PrestIds === "undefined")
			throw new Error("this.item_PrestIds is mandatory in ProductItem")
		if (typeof this.item_PrestNames === "undefined")
			throw new Error("this.item_PrestNames is mandatory in ProductItem")
		if (typeof this.item_PrestNames === "undefined")
			throw new Error("this.item_PrestNames is mandatory in ProductItem")
		if (typeof this.item_price_ati === "undefined")
			throw new Error("this.item_price_ati is mandatory in ProductItem")
		if (typeof this.page_category1 === "undefined")
			throw new Error("this.page_category1 is mandatory in ProductItem")
		if (typeof this.page_category2 === "undefined")
			throw new Error("this.page_category2 is mandatory in ProductItem")
		if (typeof this.item_variant === "undefined")
			throw new Error("this.item_variant is mandatory in ProductItem")
		if (typeof this.item_ville_name === "undefined")
			throw new Error("this.item_ville_name is mandatory in ProductItem")
		if (typeof this.item_region_name === "undefined")
			throw new Error("this.item_region_name is mandatory in ProductItem")
		if (typeof this.item_pays_name === "undefined")
			throw new Error("this.item_pays_name is mandatory in ProductItem")
		if (typeof this.item_begin_date === "undefined")
			throw new Error("this.item_begin_date is mandatory in ProductItem")
		if (typeof this.item_end_date === "undefined")
			throw new Error("this.item_end_date is mandatory in ProductItem")
		if (typeof this.item_duration === "undefined")
			throw new Error("this.item_duration is mandatory in ProductItem")
		if (typeof this.item_reviews_note === "undefined")
			throw new Error("this.item_reviews_note is mandatory in ProductItem")
		if (typeof this.item_reviews === "undefined")
			throw new Error("this.item_reviews is mandatory in ProductItem")
		if (typeof this.position === "undefined")
			throw new Error("this.position is mandatory in ProductItem")
	}
}
